import { render, staticRenderFns } from "./RozliczeniaNieoplacone.vue?vue&type=template&id=32adff3e&scoped=true&"
import script from "./RozliczeniaNieoplacone.vue?vue&type=script&lang=js&"
export * from "./RozliczeniaNieoplacone.vue?vue&type=script&lang=js&"
import style0 from "./RozliczeniaNieoplacone.vue?vue&type=style&index=0&id=32adff3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32adff3e",
  null
  
)

export default component.exports